document.addEventListener('DOMContentLoaded', () => {
  const video = document.querySelector('#model-video')
  const info = document.querySelector('.js-product-info-wrapper-inner')
  const body = document.querySelector('body')
  const main = document.querySelector('main')
  const mainSlider = document.querySelector('hh-image-carousel')
  mainSlider.lock()

  const duration = 3
  const animDuration = duration * 1000
  document.documentElement.style.setProperty('--anim-duration', duration + 's')
  document.documentElement.style.setProperty(
    '--easing',
    'cubic-bezier(0.25, 1, 0.5, 1)'
  )
  document.documentElement.style.setProperty(
    '--hh-carousel-scroll-behavior',
    'auto'
  )

  body.classList.add('hide-scrollbars')

  const handlePlayerReady = () => {
    video.play()
    main.classList.add('loaded')

    setTimeout(() => {
      info.classList.add('visible')
    }, animDuration)

    setTimeout(() => {
      body.classList.remove('hide-scrollbars')
      document.documentElement.style.removeProperty(
        '--hh-carousel-scroll-behavior'
      )
      mainSlider.unlock()
    }, animDuration + 500)
  }

  setTimeout(() => {
    handlePlayerReady()
  }, 100)
})
